import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {Observable} from 'rxjs';
import {EnvironmentService} from "@iw-shop/core/services/environment.service";
import {ApiDeliveryBlockedDaysGetRequest, ApiDeliveryBlockedDaysGetResponse} from "@api/delivery-blocked-days";

@Injectable({
    providedIn: 'root'
})
export class DeliveryBlockedDaysService {

    constructor(private http: HttpClient, private store: Store<AppState>, private environmentService: EnvironmentService) {
    }

    get(): Observable<ApiDeliveryBlockedDaysGetResponse> {
        const body: ApiDeliveryBlockedDaysGetRequest = {
            id: 'deliveryBlockedDays',
            command: 'deliveryBlockedDays/get',
            params: {
                deliveryBlockedDays: {}
            }
        };
        return this.http.post<ApiDeliveryBlockedDaysGetRequest>(this.environmentService.environment.urlApi, JSON.stringify(body));
    }
}
